export enum ConsultantStaffActionTypes {
    API_RESPONSE_SUCCESS = "@@consultant_staffs/API_RESPONSE_SUCCESS",
    API_RESPONSE_ERROR = "@@consultant_staffs/API_RESPONSE_ERROR",
    CREATE_CONSULTANT_STAFF = "@@consultant_staffs/CREATE_CONSULTANT_STAFF",
    EDIT_CONSULTANT_STAFF = "@@consultant_staffs/EDIT_CONSULTANT_STAFF",
    DELETE_CONSULTANT_STAFF = "@@consultant_staffs/DELETE_CONSULTANT_STAFF",
    GET_CONSULTANT_STAFF = "@@consultant_staffs/GET_CONSULTANT_STAFF",
    GET_CONSULTANT_STAFF_BY_ADMIN = "@@consultant_staffs/GET_CONSULTANT_STAFF_BY_ADMIN",
    GET_CONSULTANT_STAFF_BY_ID = "@@consultant_staffs/GET_CONSULTANT_STAFF_BY_ID",
  }
  